

























































































































import Vue from 'vue'
import SingleFile from './SingleFile'
import SubscribeSocialMediaMonitor from '@/mixins/SubscribeSocialMediaMonitor'
// import draggable from 'vuedraggable'
import './FileSpace.scss'
import { sortBy } from 'lodash'
import { AssetGroupType, SocialMediaTypes, AssetSummary, AssetGroup } from '@/types/assets'
import { Stream, StreamsManager } from '@/types/streams'
import { SocialMediaStats } from '@/types/ops'
import AssetFolder from '@/components/FileExplorer/FileSpace/AssetFolder/AssetFolder.vue'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import SocialMediaNextCheck from './SocialMediaNextCheck/SocialMediaNextCheck.vue'
import AssetDetails from '@/components/AssetDetails/AssetDetails.vue'
import { KeyDict } from '@/types'


export default Vue.extend({
  name: 'FileSpace',
  mixins: [ SubscribeSocialMediaMonitor ],
  props: {
    inCast: {
      type: Boolean,
      default: false
    },
    sortFilter: {
      type: String,
      default: ''
    },
    updatesReady: {
      type: Boolean,
      default: false
    },
    loadingAssets: {
      type: Boolean,
      default: false
    },
    currentFolder: {
      type: String,
      default: ''
    },
    folder: {
      type: Object as () => AssetGroup | undefined,
      required: false
    },
    subfolders: {
      type: Object as () => KeyDict<AssetGroup>
    },
    streamsManager: {
      type: Object as () => StreamsManager
    },
    sourceStreams: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    type (): AssetGroupType {
      return this.folder?.type ?? AssetGroupType.Folder
    },
    isFolder (): boolean {
      return this.type === AssetGroupType.Folder
    },
    isSocialMediaType (): boolean {
      return SocialMediaTypes.includes(this.type)
    },
    assetsLoaded (): boolean {
      return !this.$store.direct.state.assets.folderAssetsLoading
    },
    hasNoFiles (): boolean {
      return this.assetsLoaded && this.assets.length === 0 && this.streams.length === 0 && Object.keys(this.subfolders).length === 0
    },
    assets (): AssetSummary[] {
      const dbassets = this.$store.direct.state.assets.assetGroupList[this.currentFolder]
      if (dbassets === undefined) {
        return []
      }
      let assets = Object.values(dbassets)
      if (this.sortFilter === 'name') {
        assets.sort((a, b) => {
          if (a.name !== undefined && b.name !== undefined) {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          }
          if (a.timestamp !== undefined && b.timestamp !== undefined) {
            return a.timestamp < b.timestamp ? 1 : -1
          }
          return 1
        })
      } else if (this.sortFilter === 'stars') {
        assets = sortBy(assets, 'stars').reverse()
      } else if (this.sortFilter === 'date') {
        assets = sortBy(assets, 'timestamp').reverse()
      }
      return assets
    },
    teamStreams (): { [ streamId: string ]: Stream } {
      return this.$store.direct.state.team.streams
    },
    twitterBackend (): SocialMediaStats|null {
      return this.$store.direct.state.opsmonitor.socialMediaMonitor
    },
    typeLabel (): string {
      let label: string = this.type
      switch (label) {
        case AssetGroupType.InstagramHashtag:
          label = 'Instagram hashtag'
          break
        case AssetGroupType.FacebookChat:
          label = 'Facebook live chat'
          break
        case AssetGroupType.YouTubeChat:
          label = 'YouTube live chat'
          break
      }
      return label
    },
    pagedAssets (): AssetSummary[] {
      const assets = this.assets
      let startNum = (this.currentPage - 1) * this.perPage
      startNum = (startNum > 0) ? startNum + 1 : startNum
      const endNum = ((this.currentPage - 1) * this.perPage) + this.perPage
      return assets.slice(startNum, endNum)
    },
    pagedAssetsOld (): AssetSummary[] {
      let found = false
      const checkid = this.lastAsset?.id ?? null
      return this.assets.filter(asset => {
        found = found || asset.id === checkid
        return found
      })
    },
    pagedAssetsNew (): AssetSummary[] {
      let found = false
      const checkid = this.lastAsset?.id ?? null
      return this.assets.filter(asset => {
        found = found || asset.id === checkid
        return !found
      })
    },
    hibernated (): boolean {
      if (this.inCast) return false
      if (this.folder === undefined) return false
      if (this.folder.id === '' || this.folder.name === '') return false
      if (this.folder?.scrape === false) return false
      if (!this.isSocialMediaType) return false
      if (this.twitterBackend === null) return false
      if (this.twitterBackend.query === undefined) return true

      let socialMediaType: string = 'twitter' // default
      let rawFolderType: string = this.type
      if (this.type === AssetGroupType.InstagramHashtag) {
        rawFolderType = 'hashtag'
        socialMediaType = 'instagram'
      } else if (this.type === AssetGroupType.FacebookChat) {
        rawFolderType = 'video'
        socialMediaType = 'facebook'
      } else if (this.type === AssetGroupType.YouTubeChat) {
        rawFolderType = 'video'
        socialMediaType = 'youtube'
      }

      const query = this.twitterBackend.query[rawFolderType + 's']
      if (query === undefined) return true

      let name = (rawFolderType === AssetGroupType.TwitterHandle ? '' : '#') + this.folder.name
      if ([AssetGroupType.FacebookChat, AssetGroupType.YouTubeChat].includes(this.type) && this.folder.remote_url) {
        let videoIdGetter = this.getVideoIdFbUrl
        if (this.type === AssetGroupType.YouTubeChat) videoIdGetter = this.getVideoIdYtUrl
        const videoId = videoIdGetter(this.folder.remote_url)
        if (videoId !== null) name = videoId
      }
      if (query[name] !== undefined) {
        const hasMatchingItem = query[name].some(item => {
          return item.social_media === socialMediaType && item.asset_group === this.folder?.id
        })
        return !hasMatchingItem
      }
      return true
    },
    streams (): Stream[] {
      if (this.streamsManager === undefined) {
        return []
      } else {
        const streamlist = [] as Stream[]
        Object.keys(this.sourceStreams).forEach(streamkey => {
          const stream = this.sourceStreams[streamkey]
          if (['caster', 'broadcast'].includes(stream.type)) {
            const activeStream = this.streamsManager[streamkey + '_lowrate']
            if (activeStream !== undefined) {
              if (this.teamStreams[streamkey] !== undefined) {
                activeStream.name = this.teamStreams[streamkey].name
              } else {
                activeStream.name = 'caster'
              }
              activeStream.streamAvailable = true
              streamlist.push(activeStream)
            } else {
              if (this.teamStreams[streamkey] !== undefined) {
                stream.name = this.teamStreams[streamkey].name
              }
              stream.id = streamkey
              stream.streamAvailable = false
              if (stream.name === undefined) {
                stream.name = 'unknown'
              }
              streamlist.push(stream)
            }
          }
        })
        return streamlist.sort((stream1, stream2) => stream1.name.localeCompare(stream2.name))
      }
    }
  },
  data: () => ({
    list: [],
    currentPage: 1,
    perPage: 0,
    selectedAssetId: '',
    previousAssetId: '',
    nextAssetId: '',
    showDetails: false,
    isLoading: false,
    lastAsset: null as AssetSummary | null
  }),
  watch: {
    assets (newVal: AssetSummary[], oldVal: AssetSummary[]) {
      if (oldVal.length === 0 && newVal.length !== 0) {
        const scrollWrap = this.$refs.scrollwrap as Element
        scrollWrap.scrollTop = 1
        this.lastAsset = this.assets[0]
      }
    }
  },
  methods: {
    showPreviousDetails () {
      this.showAssetDetails(this.previousAssetId)
    },
    showNextDetails () {
      this.showAssetDetails(this.nextAssetId)
    },
    closeAssetDetails () {
      this.showDetails = false
      this.selectedAssetId = ''
      this.previousAssetId = ''
      this.nextAssetId = ''
    },
    showAssetDetails (assetId) {
      this.selectedAssetId = assetId
      const currentAssetIndex = this.assets.findIndex(a => a.id === this.selectedAssetId)

      if (currentAssetIndex > -1) {
        const previousIndex = currentAssetIndex - 1
        this.previousAssetId = (previousIndex >= 0) ? this.assets[previousIndex].id : ''

        const nextIndex = currentAssetIndex + 1
        this.nextAssetId = (nextIndex < this.assets.length) ? this.assets[nextIndex].id : ''
      }

      this.showDetails = true
    },
    deleteFolder (folder) {
      this.$emit('deleteFolder', folder)
    },
    onscroll (event) {
      if (event.target.scrollTop === 0) {
        if (this.assets.length > 0) {
          this.lastAsset = this.assets[0]
        }
        event.target.scrollTop = 1
      }
    },
    checkMove () {
      const uploadBox = this.$refs.uploadbox as Element
      if (this.$refs.uploadbox !== undefined && uploadBox.previousElementSibling !== null) {
        if (uploadBox !== null && uploadBox.parentNode !== null) {
          uploadBox.parentNode.insertBefore(uploadBox, uploadBox.previousElementSibling)
        }
      }
    },
    // see folder.vue
    // fileAdded (evt): void {
    //   if (evt.item.attributes['data-asset-type'].value !== 'tweet') {
    //     const item = {
    //       file_id: evt.item.attributes['data-asset-id'].value,
    //       name: evt.item.attributes['data-asset-name'].value,
    //       folder: this.folder.id,
    //       folder_name: this.folder.name
    //     }
    //     this.$store.direct.dispatch.assets.assetDroppedOnFolder(item).then(() => {
    //       this.$message({
    //         type: 'success',
    //         message: `${item.name} has been added to the ${
    //           item.folder_name
    //         } folder`
    //       })
    //     }).catch(error => {
    //       console.error('folderDrop error', error)
    //     })
    //   }
    // },
    getId (id) {
      return id.replace('_lowrate', '')
    },
    selectFolder (folder: AssetGroup | string) {
      this.isLoading = true
      setTimeout(() => this.isLoading = false, 2000)
      this.$emit('selectFolder', folder)
    },
    getVideoIdFbUrl (url: string): string|null {
      try {
        const urlObj = new URL(url)
        const videoId = urlObj.searchParams.get('v')
        if (videoId !== null) return videoId
        const pathParts = urlObj.pathname.split('/')
        if (pathParts.length < 4) return null
        return pathParts[3]
      } catch {}
      return null
    },
    getVideoIdYtUrl (url: string): string|null {
      try {
        const urlObj = new URL(url)
        const videoId = urlObj.searchParams.get('v')
        if (videoId !== null) return videoId
      } catch {}
      return null
    }
  },
  components: {
    SingleFile,
    'clip-loader': ClipLoader,
    SocialMediaNextCheck,
    AssetDetails,
    AssetFolder
  }
})
